import { makeStyles } from 'tss-react/mui';
import { alpha, Theme } from '@mui/material';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex', height: '90vh', width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
  },
  bg: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    background: 'rgba(50,50,50,0.8)', // gray with transparency
    zIndex: 1000,
    pointerEvents: 'auto',
  },
  component: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    zIndex: 2000, // higher than other content
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'auto', // allow interaction with overlay
  },
  canvas: {
    width: 600,
    minWidth: 400,
    zIndex: 3000,
    backgroundColor: alpha('#fff', 1),
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // minHeight: 600, // optional: ensures some height for centering
  },
  content: {
    marginTop: 45,
    flexGrow: 1,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  contentShift: {
    marginTop: 45,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 340,
  },
  tField: {
    display: 'flex',
    backgroundColor: alpha('#fff', 0.4),
    // border: '2px solid orange',
    '& label': { fontSize: 20, height: 45, lineHeight: .8, backgroundColor: '1px solid #4f4d4c', },
    height: 45,
    //'& label.Mui-focused': { top: 12, animationIterationCount: 1, transform: 'translate(0, -10px) scale(1)', fontSize: '.75em', color: '#d30535', },
    //'& .MuiInputLabel-formControl': { top: 11, left: 6, position: 'absolute', transform: 'translate(0, 0) scale(1)', color: '#d30535', },
    '& .MuiInput-underline:after': { height: 45, width: 0, fontSize: 20 },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      fontSize: 20,
      border: '1px solid #c4c4c4',
    },
    // ...existing styles...
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: '#d30535',
    },
    '& .MuiInput-underline.Mui-error:after': {
      borderBottomColor: '#d30535',
    },
    // (Note: space or no space after `&` matters. See SASS "parent selector".)
    '& .MuiOutlinedInput-root': {
      color: 'black',
      height: 47,
      fontSize: 20,
      // - The Input-root, inside the TextField-root
      '& fieldset': {
        border: '2px solid white',
        /* - The <fieldset> inside the Input-root */
      },
      '&:hover fieldset': {},
      '&.Mui-focused ': {
        backgroundColor: alpha('#fff', 0.8),
      },
    },
    // Remove arrows for Chrome, Safari, Edge
    '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    // Remove arrows for Firefox
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
  },
  grd: { border: 'none', marginRight: 10 },
  formError: { fontSize: '1em', marginTop: '30px', color: 'red', align: 'center' },
}),
);